import { KeyRound, MessageSquare, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { telHref } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

const NAV = [
  ["why-choose-us", "Why Us"],
  ["services", "Services"],
  ["our-work", "Our Work"],
  ["reviews", "Reviews"],
  ["contact", "Contact"],
];

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export const Header = ({ settings, onHome = true }) => {
  const phone = settings?.primary_phone;
  return (
    <header
      className="sticky top-0 z-40 w-full border-b border-zinc-800/80 bg-[#121214]/90 backdrop-blur-md"
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-3 py-2.5 sm:px-8">
        <Link to="/" className="shrink-0" data-testid="header-logo-link" aria-label="Jimmyz Restoz home">
          <Logo logo={settings?.logo} testId="header-logo" />
        </Link>
        {onHome && (
          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map(([id, label]) => (
              <button
                key={id}
                onClick={() => scrollToId(id)}
                className="font-sub text-sm uppercase tracking-widest text-zinc-300 transition-colors hover:text-[#FFD23F]"
                data-testid={`nav-${id}`}
              >
                {label}
              </button>
            ))}
          </nav>
        )}
        <div className="flex items-center gap-2">
          {onHome && (
            <button onClick={() => scrollToId("message")} className="btn-ghost hidden h-11 px-4 text-sm sm:inline-flex" data-testid="header-message-us-button">
              <MessageSquare className="h-4 w-4" /> Message Us
            </button>
          )}
          {phone && (
            <a href={telHref(phone)} className="btn-gold h-11 px-3 text-sm sm:px-4 sm:text-base" data-testid="header-call-link">
              <Phone className="h-4 w-4" strokeWidth={2.5} />
              <span>{phone}</span>
            </a>
          )}
          <Link
            to="/admin"
            aria-label="Owner portal"
            title="Owner portal"
            className="grid h-11 w-11 shrink-0 place-items-center rounded-md border border-[#FFD23F]/40 text-[#FFD23F] transition-colors hover:bg-[#FFD23F] hover:text-[#121214]"
            data-testid="header-owner-portal-link"
          >
            <KeyRound className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </header>
  );
};
